import { render, staticRenderFns } from "./ThemeSelectSnackbar.vue?vue&type=template&id=6dd1d9e3&scoped=true"
import script from "./ThemeSelectSnackbar.vue?vue&type=script&lang=js"
export * from "./ThemeSelectSnackbar.vue?vue&type=script&lang=js"
import style0 from "./ThemeSelectSnackbar.vue?vue&type=style&index=0&id=6dd1d9e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd1d9e3",
  null
  
)

export default component.exports